import React, { useState,Component, useMemo,useEffect } from 'react';
import {Switch} from '@mui/material';
import DataTable from "../../_Components/DataTable";

import _ from "lodash";
import SwalMessage from '../../_Components/SwalMessage';
import ApiKishPortInfo from "../../../../core/api/api.kishPortInfo";
import { Button } from "react-bootstrap";

function DataGridKishPortInfo({ data, setShowModalNewContent, setSelectedContent }) {

    const handleChangeisEnabled = (name) => event => {
        callApiService(name,1);
    }
    async function callApiService(item,flag) {

        //console.log("item",item)
        const response = await ApiKishPortInfo.updateKishPortInfoStatus({ 
            id: item.id,
            isEnabled: !item.isEnabled
            });
        if (response.succeeded == true)
            (document.getElementById('submitButton')).click();

        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    }
 
    const columns = useMemo(
        () => [
            {
                accessor: "id",
                Header: "شماره",
                minWidth: 50,
            },
            {
                Header: "پیام",
                minWidth: '100px',
                Cell: ({ row }) => (
                  
                        !_.isEmpty(row.original.message) ?
                    <div dangerouslySetInnerHTML={{__html: `${row.original.message.substring(0,100)}`}}></div>
                    :"بدون پیام"
                   

                )
            },
            {
                accessor: "createdPersianTime",
                Header: "تاریخ انتشار",
                minWidth: 50,
                align: "center"
              },
             {
                Header: "وضعیت پیام",
                minWidth: '100px',
                align: "center",
                Cell: ({ row }) => (
                    <div className="text-center">
                        
                        <Switch
                            checked={row.original.isEnabled== 0 ? 0 : 1 }
                            //checked={state.checkedA}
                            value="row.original.isEnabled"
                            color="primary"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeisEnabled(row.original)}
                        />
                    </div>
                )
            },
            
             {
                Header: 'عملیات',
                accessor: '',
                minWidth: 150,
                align: "center",
                Cell: ({ row }) => (
                    <div className="text-center">

                        {/* ویرایش */}
                        {/* <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/promoCategoryAgent/${row.original.id}`}>
                            <i className='far fa-edit text-small'></i>
                        </Link> */}
      
                     
                     {/* <Link className="btn btn-light-primary btn-sm mr-2 btn-icon"
                     key={0}
                     to={{
                         pathname: `/createOrEditKishPortInfo/${row.original.id}`,
                         state: { neWKishPortInfo: true ,
                                 kishPortInfoId :row.original.id,
                                 
                         }
                     }}
                 >
                    <i className='far fa-edit text-small'></i>
              </Link> */}
              <Button
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                            onClick={() => {
                                setSelectedContent(row.original.id);
                                setShowModalNewContent(true);
                            }}
                        >
                            <i className='far fa-edit text-small'></i>
                        </Button>
            
                         {/* حذف */}
                           {/* <div className="btn btn-light-primary btn-sm mr-2 btn-icon">
                            <i className='far fa-trash-alt text-small'    onClick={() => { {checkBoxList.some((item)=>item.id==row.original.id) ?  
                                                    handleRemoveItem(checkBoxList,1):  handleRemoveItem(row.original,0)}}}>                                                        
                                                    </i>
                            </div> */}
                      
                        
                    </div>
                )
            }
        ]);

    const config = {
        page_size: 10,
        length_menu: [10, 20, 50, 100],
        show_filter: false,
        show_pagination: true,
        pagination: 'advance',
        button: {
            excel: false,
            print: false
        },
        language: {
            length_menu: " _MENU_  رکورد در هر صفحه",
            filter: "جستجو ...",
            info: " _START_ - _END_ از _TOTAL_ رکورد",
            pagination: {
                first: "First",
                previous: <i className='fa fa-chevron-right'></i>,
                next: <i className='fa fa-chevron-left'></i>,
                last: "Last"
            }
        }
    }
    return (
        <div>
     
            <DataTable
                config={config}
                columns={columns}
                data={data}
            />
        </div>
    )
}

export default DataGridKishPortInfo;